// extracted by mini-css-extract-plugin
export default {"lengthIndicator":"TextArea_lengthIndicator__pAOZd","wrapper":"TextArea_wrapper__wzzoS"};